import { isStandardRole } from '@/features/roles';
import { Role } from '@customerio/hydra-permissions/roles';
import { DropdownMenuItem, Text } from '@customerio/pluma-components/react';
import * as styles from './user-role-section.css';

type UserRole = {
  name: string;
};

type UserRoleSectionProps = {
  setUpWorkspaceHref: string | null;
  userRole: UserRole | null;
};

type RolePresentation = {
  description: string;
  label: string;
};

const accountAdminPresentation: RolePresentation = {
  description: 'Full access across the account',
  label: 'Account admin',
};

const workspaceAdminPresentation: RolePresentation = {
  description: 'Full access to this workspace',
  label: 'Workspace admin',
};

const authorPresentation: RolePresentation = {
  description: 'Create and edit workspace content',
  label: 'Author',
};

const viewerPresentation: RolePresentation = {
  description: 'Read-only, no editing',
  label: 'Viewer',
};

const rolePresentations = {
  [Role.Admin]: accountAdminPresentation,
  [Role.Manager]: workspaceAdminPresentation,
  [Role.Author]: authorPresentation,
  [Role.AuthorRedacted]: authorPresentation,
  [Role.AuthorRedactedSensitive]: authorPresentation,
  [Role.AuthorRedactedAll]: authorPresentation,
  [Role.Viewer]: viewerPresentation,
  [Role.ViewerRedacted]: viewerPresentation,
  [Role.ViewerRedactedSensitive]: viewerPresentation,
  [Role.ViewerRedactedAll]: viewerPresentation,
} satisfies Record<Role, RolePresentation>;

export function UserRoleSection({ setUpWorkspaceHref, userRole }: UserRoleSectionProps) {
  if (userRole == null && setUpWorkspaceHref == null) {
    return null;
  }

  const rolePresentation = userRole != null && isStandardRole(userRole.name) ? rolePresentations[userRole.name] : null;

  return (
    <>
      {userRole != null ? (
        <DropdownMenuItem className={styles.roleHeader}>
          {rolePresentation != null ? (
            <>
              <Text as="span" color="inherit" weight="semibold">
                {rolePresentation.label}
              </Text>{' '}
              <Text as="span" color="inherit" aria-hidden="true">
                &middot;
              </Text>{' '}
              {rolePresentation.description}
            </>
          ) : (
            userRole.name
          )}
        </DropdownMenuItem>
      ) : null}
      {setUpWorkspaceHref != null ? (
        <DropdownMenuItem href={setUpWorkspaceHref}>Set up workspace</DropdownMenuItem>
      ) : null}
    </>
  );
}
